

import { Component, Emit, Prop, Vue, Watch } from "vue-property-decorator";
import NotificationRuleConditionDetails from "./NotificationRuleConditionDetails.vue";
import NotificationRuleCondition, { DefaultNotificationRuleCondition } from "@/types/sv-data/notification-rule/NotificationRuleCondition";
import { v4 as uuidv4 } from "uuid";

@Component({
    components: {
        "notification-rule-condition-details": NotificationRuleConditionDetails
    }
})
export default class NotificationRuleConditions extends Vue {
    
    @Prop({ type: Boolean, default: false })
    private readOnly: boolean;

    @Prop({type: Array, required: true})
    private conditions: NotificationRuleCondition[];

    @Prop({ type: Boolean, default: false})
    private isEdit: boolean;

    private conditionsValidStatus: boolean[] = [];

    private mounted(): void {
        this.setConditionStatus();
    }

    private get allowDelete(): boolean {
        return this.conditions.length > 1;
    }

    @Watch("conditions") 
    private onConditionsChanged(newValue: NotificationRuleCondition[] | null, oldValue: NotificationRuleCondition[] | null): void {
        if (!newValue || 
            !oldValue || 
            newValue.length !== oldValue.length || 
            newValue[0]?.notificationRuleId !== oldValue[0]?.notificationRuleId
        ) {
            this.setConditionStatus();
        }
    }

    private setConditionStatus(): void {
        this.conditionsValidStatus = [];
        this.conditions?.forEach(() => this.conditionsValidStatus.push(this.isEdit));
        this.triggerValidationUpdate();
    }

    private addNewCondition(): void {
        this.conditions.push({...DefaultNotificationRuleCondition, key: uuidv4()});
        this.conditionsValidStatus.push(false);
        this.triggerUpdates();
    }

    private updateCondition(index: number, action: NotificationRuleCondition): void {
        Vue.set(this.conditions, index, action);
        this.triggerUpdates();
    }

    private deleteCondition(index: number): void {
        this.conditions.splice(index, 1);
        this.conditionsValidStatus.splice(index, 1);
        this.triggerUpdates();
    }

    private triggerUpdates(): void {
        this.triggerUpdateConditions();
        this.triggerValidationUpdate();
    }

    @Emit("updateConditions")
    private triggerUpdateConditions(): NotificationRuleCondition[] {
        return this.conditions;
    }

    private setIsValid(index: number, isValid: boolean): void {
        this.conditionsValidStatus[index] = isValid;
        this.triggerValidationUpdate();
    }

    private triggerValidationUpdate(): void {
        const isValid = this.conditionsValidStatus.every(status => status === true);
        this.$emit("updateValidation", isValid)
    }
}
